import { Icon, type IconProps } from "@chakra-ui/react";
import React from "react";

export function ListIcon(props: IconProps) {
  return (
    <Icon width="20px" height="20px" viewBox="0 0 20 20" fill="none" {...props}>
      <path
        d="M6.667 15H17.5M2.5 15h.008M6.667 10H17.5M2.5 10h.008M6.667 5H17.5M2.5 5h.008"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  );
}
